import React, { memo } from 'react'
import { faChevronLeft } from '@fortawesome/pro-duotone-svg-icons'

import FaIcon from '../faIcon/FaIcon'
import Button from './Button'

const BackButton = ({ t, onClick }) => {
  return (
    <Button
      startIcon={<FaIcon icon={faChevronLeft} width={16} />}
      label={t('common.back')}
      variant='text'
      color='inherit'
      onClick={onClick}
    />
  )
}

export default memo(BackButton)
